<template>
  <div class="mb-48">
    <div v-if="!getOffersWithPrices().length" class="h-group-placeholder">
      <div class="h-group-placeholder__title-box"></div>
      <div class="h-group-placeholder__cards">
        <div class="h-group-placeholder__card-box">
          <span></span>
        </div>
        <div class="h-group-placeholder__card-box">
          <span></span>
        </div>
        <div class="h-group-placeholder__card-box">
          <span></span>
        </div>
      </div>
      <div class="h-group-placeholder__button"></div>
    </div>

    <div v-if="getOffersWithPrices().length > 0" class="h-group">
      <div class="h-group__title-box" :class="color">
        <h3>{{ groupName }}</h3>
        <template v-if="window.width > 479">
          <a
            class="h-group__title-box-link"
            :href="groupUrl"
            :title="'Oferty z kategorii ' + groupName"
            >Więcej ofert
          </a>
        </template>
      </div>
      <div class="h-group__content">
        <splide :slides="getOffersWithPrices()" :options="sliderOptions">
          <splide-slide v-for="(item, idx) in getOffersWithPrices()" :key="idx">
            <T1OfferCategoryRowCard
              :regionName="item.child.nazwa"
              :offersPageUrl="item.child.parametry"
              :imageName="getNameForImage(item.url)"
              :price="getPrice(item.url)"
            />
          </splide-slide>
        </splide>
      </div>
      <template v-if="window.width <= 479">
        <div class="mt-24 text-center">
          <a
            class="btn btn-lg btn-d-blue pl-48 pr-48"
            :href="groupUrl"
            :title="'Oferty z kategorii ' + groupName"
            >Więcej ofert</a
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import * as CONFIG from "./config.js";
import T1OfferCategoryRowCard from "./T1OfferCards/T1OfferCategoryRowCard";

export default {
  name: "offers-category-group-row-section",
  components: {
    T1OfferCategoryRowCard,
  },
  props: {
    type: String,
    optionsUrl: String,
    pricesUrl: String,
    color: String,
    groupName: String,
    groupUrl: String,
    nntab: String,
  },
  data: () => ({
    oferty: [],
    ceny: [],
    cenyOferta: {},
    sliderOptions: {
      pagination: false,
      perMove: 1,
      perPage: 3,
      breakpoints: {
        999: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        479: {
          perPage: 1,
        },
      },
      gap: "24px",
    },
    window: {
      width: 0,
    },
  }),

  methods: {
    getOffersWithPrices() {
      let pricesArr = [];
      let prices = this.ceny;
      let offers = this.oferty;

      prices.forEach(function (obj) {
        if (obj.cenamin !== "") {
          offers.forEach(function (objj) {
            if (objj.url == obj.url) {
              pricesArr.push(objj);
            }
          });
        }
      });
      return pricesArr;
    },
    getPrice(url) {
      let offerPrice;
      let prices = this.ceny;

      prices.forEach(function (obj) {
        if (obj.cenamin !== "" && obj.url == url) {
          offerPrice = obj.cenamin;
        }
      });
      return offerPrice;
    },
    getRodzajOfertyCenyData() {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.pricesUrl;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function (data) {
          var xmlObj = jQuery(data);
          var arr = [];
          xmlObj.find("Grupa").each(function (index) {
            var newObj = {};
            newObj.cenamin = jQuery(this).attr("cenamin");
            newObj.grupa = jQuery(this).attr("id");
            newObj.url = jQuery(this).attr("url");
            // if (newObj.cenamin !== "" && newObj.grupa === "last") {
            if (newObj.cenamin !== "") {
              arr.push(newObj);
              that.cenyOferta[newObj.url] = newObj;
            }
          });
          that.ceny = arr.slice(0);
        },
        error: function (e) {
          console.log(e);
          console.log("Ajax Error");
        },
      });
      return result;
    },
    getRodzajOfertyData() {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.optionsUrl + "?id=" + this.type;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function (data) {
          var xmlObj = jQuery(data);
          var arr = [];
          xmlObj.find("item").each(function (index) {
            var newObj = {};
            newObj.zdjecie = jQuery(this).attr("zdjecie");
            newObj.url = jQuery(this).attr("url");
            var subObj = {};
            subObj.prefix = jQuery(this).find("prefix").text();
            subObj.nazwa = jQuery(this).find("nazwa").text();
            var ntab = jQuery(this).find("ntab").text();
            subObj.parametry = jQuery(this).find("parametry").text();
            newObj.child = subObj;
            if (that.nntab === ntab && subObj.prefix !== "") {
              arr.push(newObj);
            }
          });
          that.oferty = arr.slice(0);
        },
        error: function (e) {
          console.log(e);
          console.log("Ajax Error");
        },
      });
      return result;
    },
    getNameForImage(url) {
      let countryName = url.substr(url.lastIndexOf("/") + 1);
      return countryName.split(".")[0];
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
  },
  mounted() {
    this.getRodzajOfertyCenyData();
    this.getRodzajOfertyData();
  },
};
</script>

<style lang="scss" scoped>
.h-group {
  @media (min-width: $screen-md) {
    display: flex;
    height: 300px;
  }

  &__title-box {
    background-color: $blue-default;
    border-radius: 2px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    margin-bottom: 24px;

    > h3 {
      font-size: 22px;
      margin-bottom: 0;
      line-height: 1;

      &::first-letter {
        text-transform: uppercase;
      }
    }

    @media (min-width: $screen-md) {
      align-items: flex-start;
      flex: 0 0 230px;
      flex-direction: column;
      margin-right: 32px;
      padding: 18px;
      margin-bottom: 0;

      > h3 {
        font-size: 26px;
        line-height: 1.15;
      }
    }

    &.orange {
      background-color: #ee8810;
    }

    &.blue {
      background-color: #2693ea;
    }

    &.green {
      background-color: #5bb718;
    }
  }

  &__title-box-link {
    color: #ffffff;
  }

  &__content {
    flex: 0 1 100%;
    overflow: hidden;
  }
}

::v-deep .h-group__content {
  .splide {
    &__arrow {
      background-color: #fff;
      opacity: 0.85;
      width: 2.25em;
      height: 2.5em;
      top: 110px;

      &:hover {
        opacity: 1;
      }

      &--prev {
        border-radius: 0 2.5em 2.5em 0;
        left: 0;
      }

      &--next {
        border-radius: 2.5em 0 0 2.5em;
        right: 0;
      }

      svg {
        fill: $blue-dark;
      }

      &:disabled {
        display: none;
      }
    }
  }
}

.h-group-placeholder {
  @media (min-width: $screen-md) {
    display: flex;
    height: 300px;
  }

  &__title-box {
    background-color: $gray-00;
    height: 51px;
    margin-bottom: 24px;

    @media (min-width: $screen-md) {
      height: 100%;
      flex: 0 0 230px;
      margin-right: 32px;
      margin-bottom: 0;
    }
  }

  &__cards {
    display: flex;
    height: 300px;
    flex-wrap: nowrap;
    margin-left: -12px;
    margin-right: -12px;
    overflow: hidden;

    @media (min-width: $screen-md) {
      width: 100%;
    }
  }

  &__card-box {
    height: 100%;
    flex: 0 0 100%;
    padding-left: 12px;
    padding-right: 12px;

    @media (min-width: $screen-xxs) {
      flex: 0 0 50%;
    }

    @media (min-width: $screen-sm) {
      flex: 0 0 percentage(1/3);
    }

    > span {
      background-color: $gray-00;
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__button {
    background-color: $gray-00;
    margin: 24px auto 0;
    width: 192px;
    height: 42px;

    @media (min-width: $screen-xxs) {
      display: none;
    }
  }
}
</style>
